import { useFlags as useLDFlags } from 'launchdarkly-react-client-sdk';
import Config from 'src/common/Config';
import useFlagOverrides from './useFlagOverrides';

export type Flags = {
  showDataUploadCounts: boolean;
  flagEnabledComplianceChecking: boolean;
  flagEnabledDocumentEdit: boolean;
  flagEnabledMeetingNoteSummarisation: boolean;
  flagEnabledMeetingNoteAdditionalInstructions: boolean;
  flagEnabledMaintenanceMode: boolean;
  flagEnabledMeetingNoteEdit: boolean;
  flagEnabledAgendaMeetingNoteReadOnly: boolean;
  flagEnabledBotMigration: boolean;
  flagEnabledObjectivesRework: boolean;
  flagEnabledTranscriptionOnClientCreation: boolean;
  flagEnabledBulkValControlCentre: boolean;
  flagEnabledMeetingNoteCitations: boolean;
  flagEnabledSiestaSteering: boolean;
  flagEnabledSiestaChats: boolean;
  flagEnabledSiestaAsyncGeneration: boolean;
  flagEnabledAutoModelTypeSelection: boolean;
  flagEnabledBatchCrudDataUpload: boolean;
  flagEnabledInlineEdit: boolean;
  flagEnabledFamilyFlowFrontend: boolean;
  flagEnabledFamilyPeerModel: boolean;
  flagEnabledFamilyRoleModel: boolean;
  flagEnabledIndividualDetailsRework: boolean;
  flagEnabledFamilyScreenRework: boolean;
  flagEnabledFinancialRework: boolean;
  flagEnabledResponsiveMenus: boolean;
  flagEnabledLlmDispatcherAdmin: boolean;
  flagEnabledResumeCurrentChat: boolean;
  flagEnabledAdvisorSortAndFilter: boolean;
  flagEnabledCompanyDocuments: boolean;
  flagEnabledClientSearchFullName: boolean;
  flagEnabledFamilyCashflowsRevamp: boolean;
  flagEnabledFamilyMeetingsRework: boolean;
  flagEnabledIndividualMeetingsRework: boolean;
  flagEnabledCreateUserModalRefactor: boolean;
  flagEnabledSiestaSkillManager: boolean;
  flagEnabledShowNonConflictingFields: boolean;
  flagEnabledFamilyDocumentsRevamp: boolean;
  flagEnabledPaginatedClients: boolean;
  flagEnabledAddExistingClientToMeeting: boolean;
  flagEnabledTranscriptDocxDownload: boolean;
  flagEnabledPreventAddConflicts: boolean;
};

export function useFlags(): Flags {
  const ldFlags = useLDFlags<Flags>();
  const { overrides } = useFlagOverrides();
  if (!Config.isDev()) return ldFlags;
  return { ...ldFlags, ...overrides };
}
